import React, { useContext, useEffect, useState } from "react";
import {
  Link,
  // ScrollRestoration, // Not used as useEffect handles scroll
  useNavigate,
  useParams,
} from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Thumbs, FreeMode } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css/free-mode";

import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { calculateDiscountPercentage } from "../utils/discountCalculater"; // Path thik ache kina dekhe neben
import VariantSelector from "../components/VariantSelector"; // Path thik ache kina dekhe neben
import toast from "react-hot-toast";
import { CartContext } from "../context/CartProvider";
import { WishListContext } from "../context/WishListProvider";

// Font Awesome icons (jemon ta age chilo)
// import '@fortawesome/fontawesome-free/css/all.min.css'; // Project-e globally import kora thakle ekhane dorkar nei
import ProductCard from './../components/Home/ProductCard';

const ProductDetails = () => {
  const { addToCart } = useContext(CartContext);
  const { id } = useParams();
  const baseUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const [productData, setProductData] = useState(null); // Product data state
  const [reletedProduct, setReletedProduct] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [selectedVariant, setSelectedVariant] = useState(null);
  // const [addedItems, setAddedItems] = useState([]); // Ei state-ta ageo use hoyni

  const { addWishList, getExistingWishlist } = useContext(WishListContext);
  // productData load howar por isAddedWishlist check hobe
  const isAddedWishlist = productData?.product?._id
    ? getExistingWishlist(productData.product._id)
    : false;

  const [thumbsSwiper, setThumbsSwiper] = useState(null); // For Swiper thumbnail gallery

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLoading(true);
    axios
      .get(`${baseUrl}productdetails/${id}`)
      .then((res) => {
        setProductData(res.data);
        // Default variant selection jodi variable product na hoy ba ektai variant thake
        if (
          res.data?.product?.variation !== "Variable" ||
          (res.data?.product?.variants?.length === 1 &&
            res.data?.product?.variants)
        ) {
          if (
            res.data.product.variants &&
            res.data.product.variants.length > 0
          ) {
            setSelectedVariant(res.data.product.variants[0]);
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching product details:", err);
        toast.error("Product details load kora jayni.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [baseUrl, id]);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(`${baseUrl}productlist/${productData?.product?.category}`)
      .then((res) => {
        setReletedProduct(res.data.products);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false)
      });
  }, [productData, baseUrl]);

  console.log("releted product", reletedProduct);

  const product = productData?.product; // Main product object

  const handleAddToCart = () => {
    if (!product) {
      toast.error("Product details paoa jacche na.");
      return;
    }
    const isVariableProduct = product?.variation === "Variable";
    if (
      isVariableProduct &&
      !selectedVariant &&
      product.variants &&
      product.variants.length > 0
    ) {
      toast.error("Add korar age variant select korun."); // Replaced alert
      return;
    }

    const cartProduct = {
      product_id: product._id,
      product_name: product.product_name,
      quantity: 1,
      price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      discount_price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      reguler_price:
        selectedVariant?.other_attributes?.price || product?.reguler_price,
      stock:
        selectedVariant?.other_attributes?.stock ||
        product?.stock ||
        "In stock",
      productImage: product?.productImage, // Main image for cart
      selectedAttributes: selectedVariant || {},
    };
    addToCart(cartProduct);
    // toast.success(`${product.product_name} cart-e add kora hoyeche!`); // CartProvider handle korbe
  };

  const handleAddWishList = () => {
    if (!product) {
      toast.error("Product details paoa jacche na.");
      return;
    }
    const isVariableProduct = product?.variation === "Variable";
    if (
      isVariableProduct &&
      !selectedVariant &&
      product.variants &&
      product.variants.length > 0
    ) {
      toast.error("Wishlist-e add korar age variant select korun."); // Replaced alert
      return;
    }
    const wishListProduct = {
      product_id: product._id,
      product_name: product.product_name,
      quantity: 1,
      price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      discount_price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      reguler_price:
        selectedVariant?.other_attributes?.price || product?.reguler_price,
      stock:
        selectedVariant?.other_attributes?.stock ||
        product?.stock ||
        "In stock",
      productImage: product?.productImage,
      selectedAttributes: selectedVariant || {},
    };
    addWishList(wishListProduct);
  };

  const handleBuyNow = () => {
    if (!product) {
      toast.error("Product details paoa jacche na.");
      return;
    }
    const isVariableProduct = product?.variation === "Variable";
    if (
      isVariableProduct &&
      !selectedVariant &&
      product.variants &&
      product.variants.length > 0
    ) {
      toast.error("Buy korar age variant select korun."); // Replaced alert
      return;
    }
    const buyProduct = {
      product_id: product._id,
      product_name: product.product_name,
      quantity: 1,
      price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      discount_price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      reguler_price:
        selectedVariant?.other_attributes?.price || product?.reguler_price,
      stock:
        selectedVariant?.other_attributes?.stock ||
        product?.stock ||
        "In stock",
      productImage: product?.productImage,
      selectedAttributes: selectedVariant || {},
    };
    addToCart(buyProduct); // Add to cart first
    navigate("/checkout", { state: { product: [buyProduct] } }); // Then navigate
  };

  const { data: categoriesData } = useQuery({
    queryKey: ["categories-list-details-page"],
    queryFn: async () => {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}catagorylist`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) throw new Error("Failed to fetch categories");
      return res.json();
    },
  });
  const categories = categoriesData?.catagories || [];

  const getCategoryName = (categoryId) => {
    const category = categories.find((cat) => cat._id === categoryId);
    return category ? category.catagoryname : "Category";
  };

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh" }}
      >
        <div
          className="spinner-border text-danger"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="container text-center py-5">
        <h2 className="mb-3">Product Not Found</h2>
        <Link to="/shop" className="btn btn-danger">
          Go to Shop
        </Link>
      </div>
    );
  }

  const displayPrice =
    selectedVariant?.other_attributes?.discount_price ||
    product?.discount_price;
  const regularPrice =
    selectedVariant?.other_attributes?.price || product?.reguler_price;
  const discountPercentage = calculateDiscountPercentage(
    regularPrice,
    displayPrice
  );
  const allImages = [
    product.productImage,
    ...(product.galleryImages || []),
  ].filter(Boolean); // Filter out any null/undefined images

  const breadcrumbStyle = {
    fontSize: "0.875rem",
    color: "#6c757d",
  };
  const breadcrumbLinkStyle = {
    color: "#dc3545", // Bootstrap danger color for links
    textDecoration: "none",
  };
  const breadcrumbActiveStyle = {
    color: "#343a40",
    fontWeight: 500,
  };

  const mainImageSwiperStyle = {
    border: "1px solid #dee2e6",
    borderRadius: "0.5rem",
    backgroundColor: "#fff",
    maxHeight: "500px", // Max height for main image
  };
  const mainImageStyle = {
    width: "100%",
    height: "auto", // Maintain aspect ratio
    maxHeight: "480px", // Ensure it fits within swiper
    objectFit: "contain", // Show full image, might leave empty space
    padding: "1rem", // Padding around image
  };
  const thumbImageStyle = {
    width: "100%",
    height: "80px", // Fixed height for thumbnails
    objectFit: "cover",
    cursor: "pointer",
    border: "2px solid transparent",
    borderRadius: "0.375rem",
  };
  const activeThumbStyle = {
    borderColor: "#dc3545", // Highlight active thumb
  };

  const actionButtonStyle = {
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
    fontWeight: "500",
    borderRadius: "0.375rem",
    transition: "all 0.2s ease",
  };

  return (
    <>
      {/* Product Details Section */}
      <section className="py-4 py-md-5" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container">
          {" "}
          {/* Bootstrap container */}
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb" className="mb-4" style={breadcrumbStyle}>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" style={breadcrumbLinkStyle}>
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/shop" style={breadcrumbLinkStyle}>
                  Shop
                </Link>
              </li>
              {product.category && (
                <li className="breadcrumb-item">
                  <Link
                    to={`/category/${product.category}`}
                    style={breadcrumbLinkStyle}
                  >
                    {getCategoryName(product.category)}
                  </Link>
                </li>
              )}
              <li
                className="breadcrumb-item active"
                aria-current="page"
                style={breadcrumbActiveStyle}
              >
                {product.product_name}
              </li>
            </ol>
          </nav>
          <div className="row g-4 g-lg-5">
            {" "}
            {/* Bootstrap row with gutters */}
            {/* Image Gallery Column */}
            <div className="col-lg-6">
              <div className="mb-3">
                <Swiper
                  style={mainImageSwiperStyle}
                  spaceBetween={10}
                  navigation={allImages.length > 1}
                  thumbs={{
                    swiper:
                      thumbsSwiper && !thumbsSwiper.destroyed
                        ? thumbsSwiper
                        : null,
                  }}
                  modules={[Navigation, Thumbs, Pagination]}
                  pagination={{ clickable: true }}
                  className="main-image-swiper"
                >
                  {allImages.map((img, index) => (
                    <SwiperSlide key={`main-${index}`}>
                      <img
                        src={
                          img ||
                          "https://placehold.co/600x500/E9ECEF/333?text=Product+Image"
                        }
                        alt={`${product.product_name} - view ${index + 1}`}
                        style={mainImageStyle}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://placehold.co/600x500/E9ECEF/333?text=Image+Error";
                        }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            {/* Product Info Column */}
            <div className="col-lg-6">
              <div className="ps-lg-4">
                {" "}
                {/* Padding for larger screens */}
                <h1 className="h2 fw-bold mb-2" style={{ color: "#212529" }}>
                  {product.product_name}
                </h1>
                {/* Review Placeholder */}
                <div className="d-flex align-items-center mb-3">
                  <div style={{ color: "#ffc107" }}>
                    {" "}
                    {/* Yellow for stars */}
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="fas fa-star"></i>
                    ))}
                  </div>
                  <span className="ms-2 text-muted small">
                    (1 review) - Placeholder
                  </span>
                </div>
                {/* Price */}
                <div className="mb-4">
                  <span className="h3 fw-bold text-danger me-2">
                    £{parseFloat(displayPrice || 0).toFixed(2)}
                  </span>
                  {regularPrice &&
                    parseFloat(regularPrice) >
                      parseFloat(displayPrice || 0) && (
                      <span className="h5 text-muted text-decoration-line-through me-2">
                        £{parseFloat(regularPrice).toFixed(2)}
                      </span>
                    )}
                  {discountPercentage > 0 && (
                    <span className="badge bg-success-subtle text-success-emphasis rounded-pill">
                      {discountPercentage}% OFF
                    </span>
                  )}
                </div>
                {/* Stock Status */}
                <p
                  className={`mb-3 fw-medium ${
                    (selectedVariant?.other_attributes?.stock ||
                      product.stock) === "Out of stock"
                      ? "text-danger"
                      : "text-success"
                  }`}
                >
                  Status:{" "}
                  {selectedVariant?.other_attributes?.stock ||
                    product.stock ||
                    "In stock"}
                </p>
                {/* Variant Selector */}
                {product.variation === "Variable" &&
                  product.variants &&
                  product.variants.length > 0 && (
                    <div className="mb-4">
                      <VariantSelector
                        product={productData}
                        setSelectedVariant={setSelectedVariant}
                        // VariantSelector-er bhitore styling thakle bhalo, noile ekhane wrapper div diye style kora jete pare
                      />
                    </div>
                  )}
                {/* Short Description */}
                {(product.short_description || product.description) && (
                  <div
                    className="text-muted mb-4"
                    style={{ fontSize: "0.95rem", lineHeight: "1.6" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        product.short_description ||
                        (product.description?.length > 200
                          ? product.description.substring(0, 200) + "..."
                          : product.description),
                    }}
                  />
                )}
                {/* Action Buttons */}
                <div className="d-grid gap-2 d-sm-flex mb-4">
                  <button
                    onClick={handleAddToCart}
                    disabled={
                      (selectedVariant?.other_attributes?.stock ||
                        product.stock) === "Out of stock"
                    }
                    className="btn btn-lg flex-grow-1"
                    style={{
                      ...actionButtonStyle,
                      backgroundColor: "#dc3545",
                      color: "white",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#c82333")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#dc3545")
                    }
                  >
                    <i className="fas fa-cart-plus me-2"></i> Add to Cart
                  </button>
                  <button
                    onClick={handleBuyNow}
                    disabled={
                      (selectedVariant?.other_attributes?.stock ||
                        product.stock) === "Out of stock"
                    }
                    className="btn btn-lg btn-dark flex-grow-1"
                    style={actionButtonStyle}
                  >
                    <i className="fas fa-bolt me-2"></i> Buy Now
                  </button>
                  <button
                    onClick={handleAddWishList}
                    title={
                      isAddedWishlist ? "Added to Wishlist" : "Add to Wishlist"
                    }
                    className="btn btn-lg btn-outline-danger"
                    style={{
                      ...actionButtonStyle,
                      backgroundColor: "transparent",
                      color: "#dc3545",
                      borderColor: "#dc3545",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor =
                        "rgba(220, 53, 69, 0.1)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <i
                      className={`${isAddedWishlist ? "fas" : "far"} fa-heart`}
                    ></i>
                  </button>
                </div>
                {/* Meta Information */}
                <div className="text-muted small">
                  {product.sku && (
                    <p className="mb-1">
                      <strong>SKU:</strong>{" "}
                      {selectedVariant?.other_attributes?.sku || product.sku}
                    </p>
                  )}
                  {product.category && (
                    <p className="mb-1">
                      <strong>Category:</strong>{" "}
                      <Link
                        to={`/category/${product.category}`}
                        style={{ color: "#dc3545", textDecoration: "none" }}
                      >
                        {getCategoryName(product.category)}
                      </Link>
                    </p>
                  )}
                  {product.tags && product.tags.length > 0 && (
                    <p className="mb-1">
                      <strong>Tags:</strong>{" "}
                      {product.tags.map((tag, index) => (
                        <React.Fragment key={index}>
                          <Link
                            to={`/tag/${tag.trim()}`}
                            style={{ color: "#dc3545", textDecoration: "none" }}
                          >
                            {tag.trim()}
                          </Link>
                          {index < product.tags.length - 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                    </p>
                  )}
                </div>
                {/* Social Share */}
                <div className="mt-4 pt-3 border-top">
                  <strong className="small me-2">Share:</strong>
                  <Link
                    to="#"
                    title="Facebook"
                    className="btn btn-outline-secondary btn-sm me-2"
                    style={{ borderColor: "#adb5bd" }}
                  >
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                  <Link
                    to="#"
                    title="Twitter"
                    className="btn btn-outline-secondary btn-sm me-2"
                    style={{ borderColor: "#adb5bd" }}
                  >
                    <i className="fab fa-twitter"></i>
                  </Link>
                  <Link
                    to="#"
                    title="Pinterest"
                    className="btn btn-outline-secondary btn-sm me-2"
                    style={{ borderColor: "#adb5bd" }}
                  >
                    <i className="fab fa-pinterest"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Description/Reviews Tabs Section */}

      <div className=" container me-auto" style={{
        borderTop:"2px solid #d9d9d9"
      }}></div>

      <section className=" container me-auto"> 
        <h3  style={{
          margin:"16px 0"
        }}>You Might Also Like</h3>
        <div  className=" row gap-4">
           
           {
            reletedProduct.slice(0,8).map(singleProduct => <ProductCard item={singleProduct}/>)
           }
          
        </div>
      </section>
    </>
  );
};

export default ProductDetails;
